import React, { useState, useRef, useEffect } from 'react';
import { searchCountries, getFlagEmoji, TKD_COUNTRIES } from '../utils/tkdCountries';

function NationalityInput({ value, onChange, accentColor }) {
  const [query, setQuery]       = useState(value || '');
  const [suggestions, setSuggestions] = useState([]);
  const [open, setOpen]         = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => { setQuery(value || ''); }, [value]);

  useEffect(() => {
    const handler = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const handleInput = (val) => {
    setQuery(val.toUpperCase());
    const results = searchCountries(val);
    setSuggestions(results);
    setOpen(results.length > 0);
    const exact = TKD_COUNTRIES.find(c => c.alpha3.toUpperCase() === val.toUpperCase());
    onChange(exact ? exact.alpha3 : '');
  };

  const handleSelect = (country) => {
    setQuery(country.alpha3);
    onChange(country.alpha3);
    setSuggestions([]);
    setOpen(false);
  };

  const selectedCountry = TKD_COUNTRIES.find(c => c.alpha3 === value);
  const flag = selectedCountry ? getFlagEmoji(selectedCountry.alpha2) : '';

  return (
    <div ref={wrapRef} style={{ position: 'relative' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        {flag && <span style={{ fontSize: 20, lineHeight: 1, flexShrink: 0 }}>{flag}</span>}
        <input
          className="form-input"
          style={{ borderLeft: accentColor ? `3px solid ${accentColor}` : undefined, flex: 1 }}
          placeholder="Es. ITA, KOR, FRA…"
          value={query}
          maxLength={3}
          onChange={e => handleInput(e.target.value)}
          onFocus={() => { if (suggestions.length > 0) setOpen(true); }}
          autoComplete="off"
        />
      </div>
      {open && (
        <div style={{
          position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 200,
          background: 'var(--bg-elevated)', border: '1px solid #3f3f3f', borderRadius: 6,
          marginTop: 2, overflow: 'hidden', boxShadow: '0 4px 12px rgba(0,0,0,0.5)',
        }}>
          {suggestions.map(c => (
            <div
              key={c.alpha3}
              onMouseDown={() => handleSelect(c)}
              style={{
                padding: '7px 10px', cursor: 'pointer', display: 'flex',
                alignItems: 'center', gap: 8, fontSize: 13, transition: 'background 0.1s',
              }}
              onMouseEnter={e => e.currentTarget.style.background = 'var(--color-border-hover)'}
              onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
            >
              <span style={{ fontSize: 18 }}>{getFlagEmoji(c.alpha2)}</span>
              <span style={{ fontWeight: 700, fontFamily: 'monospace', color: 'var(--color-text)' }}>{c.alpha3}</span>
              <span style={{ color: 'var(--color-text-sub)', fontSize: 12 }}>{c.name}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default NationalityInput;
